export function backgroundFromLetter(word?: string) {
	const letter = word?.charAt(0).toUpperCase() ?? '?';

	const charCode = letter.charCodeAt(0);
	const hue = (charCode % 26) * (360 / 26); // Distribute letters across the hue spectrum

	return [
		`hsl(${hue}, 70%, 70%)`, // Light pastel colors
		letter,
	];
}
